import { PageHero } from "../components/common/PageHero";
import { FinalCta } from "../components/common/FinalCta";
import { Reveal } from "../components/motion/Reveal";
import { useC, useSite } from "../context/SiteData";
import { getMapDirectionsUrl, getMapEmbedUrl } from "../lib/maps";

const Konum = () => {
  const c = useC();
  const site = useSite();
  const mapSrc = getMapEmbedUrl(c);
  const directionsUrl = getMapDirectionsUrl(c);

  return (
    <>
      <PageHero
        title={c.ph_konum_title}
        subtitle={c.ph_konum_subtitle}
        desc={c.ph_konum_desc}
      />
      <section data-testid="konum-map-section" className="section-y">
        <div className="container-x">
          <Reveal>
            <div className="overflow-hidden border border-line" data-testid="konum-map">
              <iframe
                title="Yalı Yurt Harita"
                src={mapSrc}
                className="map-grayscale h-[380px] w-full sm:h-[480px] lg:h-[560px]"
                loading="lazy"
              />
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-6 flex flex-col justify-between gap-4 border border-line bg-white p-6 sm:flex-row sm:items-center sm:p-8">
              <div>
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-ink-400">Açık Adres</p>
                <p className="mt-2 text-lg font-bold tracking-tight text-ink-900">
                  {site.address}, {site.addressCity}
                </p>
              </div>
              <a
                href={directionsUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="konum-directions"
                className="btn-outline-dark shrink-0"
              >
                Yol Tarifi Al
              </a>
            </div>
          </Reveal>
        </div>
      </section>

      <section data-testid="konum-distances" className="border-t border-line bg-cream-200">
        <div className="container-x section-y">
          <Reveal>
            <h2 className="text-3xl font-bold tracking-tight text-ink-900 sm:text-4xl">{c.konum_dist_title}</h2>
          </Reveal>
          <Reveal delay={0.08}>
            <p className="mt-4 max-w-2xl text-base leading-relaxed text-ink-500 sm:text-lg">
              {c.konum_dist_desc}
            </p>
          </Reveal>
          <div className="mt-12 grid grid-cols-2 gap-px border border-line bg-line md:grid-cols-3">
            {c.distances.map((d, i) => (
              <Reveal key={d.place} delay={Math.min(i * 0.04, 0.25)}>
                <div className="group h-full bg-cream-50 p-6 transition-colors duration-300 hover:bg-ink-900 sm:p-7" data-testid={`distance-item-${i}`}>
                  <p className="text-2xl font-bold tracking-tight text-ink-900 transition-colors duration-300 group-hover:text-cream-50 sm:text-3xl">{d.time}</p>
                  <p className="mt-2 text-sm font-bold tracking-tight text-ink-800 transition-colors duration-300 group-hover:text-cream-50/85">{d.place}</p>
                  {d.note && <p className="mt-1 text-xs leading-relaxed text-ink-400 transition-colors duration-300 group-hover:text-cream-50/50">{d.note}</p>}
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <FinalCta />
    </>
  );
};

export default Konum;
